import React from 'react';
import PropTypes from 'prop-types';
import yaml from 'js-yaml';

export default function YamlTable({ children }) {
  const yamlContent = yaml.load(children);
  const rows = parse(yamlContent, 0);
  const maxdepth = maxDepth(rows);

  return (
    <table>
      <tbody>
        {rows.map((row, i) => {
          return (
            <>
              {row[0].isCategory && (
                // <tr key={i + ' main-category'} className="yaml__category">
                //   <th>{row[0].value}</th>
                // </tr>
                <tr key={i + ' main-category'} className="yaml__category">
                  <th colSpan={maxdepth}>{row[0].value}</th>
                </tr>
              )}
              <tr key={i}>
                {row.map((column, ind) => {
                  if (column.isCategory) return null;
                  if (column.depth) {
                    const colspan = maxdepth - column.depth;

                    return (
                      <td colSpan={colspan} key={ind}>
                        {column.value}
                      </td>
                    );
                  } else {
                    return (
                      <th rowSpan={column.rowSpan} key={ind} className={maxdepth > 2 && column.isCategory && 'header-cat'}>
                        {column.value}
                      </th>
                    );
                  }
                })}
              </tr>
            </>
          );
        })}
      </tbody>
    </table>
  );
}

// Parse is a recursive function that transforms an object in a matrix of rows and columns to construct an html table.
function parse(obj, depth) {
  if (typeof obj !== 'object') {
    return [
      [
        {
          depth: depth,
          rowSpan: 1,
          value: obj,
          isCategory: false,
        },
      ],
    ];
  }

  const matrix = [];

  for (const key in obj) {
    const leafMatrix = parse(obj[key], depth + 1);

    if (!leafMatrix || !leafMatrix[0] || !leafMatrix[0].unshift) {
      continue;
    }

    leafMatrix[0].unshift({
      value: key,
      rowSpan: leafMatrix.length,
      isCategory: 0 === depth, // target the category cell for rows with > 2 elements, the cell value is the parent object key
    });
    matrix.push(...leafMatrix);
  }

  return matrix;
}

function maxDepth(rows) {
  let maxdepth = 0;

  for (const row in rows) {
    for (const column in rows[row]) {
      if (rows[row][column].depth > maxdepth) {
        maxdepth = rows[row][column].depth;
      }
    }
  }

  return maxdepth + 1;
}

YamlTable.propTypes = {
  children: PropTypes.node,
};
